import { InjectionToken } from '@angular/core';

import { BetslipError } from '../errors/betslip-error';
import { ResultError } from '../errors/result/result-error';
import {
    IBetstationRewardTokensBetslipValidator,
    IContextBetslipValidator,
    IEditBetBetslipValidator,
    IPureBetslipValidator,
    IRewardTokensBetslipValidator,
} from './validators/betslip/validators';
import {
    IBetstationRewardTokensPickValidator,
    IContextPickValidator,
    IPureLinearPickValidator,
    IPurePickValidator,
    ITeaserBetPickValidator,
} from './validators/picks/validators';
import { IBetBuilderSlipValidator, IContextSlipValidator, IEditBetSlipValidator } from './validators/slip/validators';
import {
    IComboBetBetslipValidator,
    IEditBetTypeBetslipValidator,
    IPureTypeBetslipValidator,
    ISingleBetBetslipValidator,
    ISystemBetBetslipValidator,
    ITeaserBetBetslipValidator,
} from './validators/type/validators';

export const PURE_PICK_VALIDATORS = new InjectionToken<IPurePickValidator<ResultError>>('PURE_PICK_VALIDATORS');
export const PURE_LINEAR_PICK_VALIDATORS = new InjectionToken<IPureLinearPickValidator<ResultError>>('PURE_LINEAR_PICK_VALIDATORS');
export const CONTEXT_PICK_VALIDATORS = new InjectionToken<IContextPickValidator<ResultError>>('CONTEXT_PICK_VALIDATORS');
export const TEASER_PICK_VALIDATORS = new InjectionToken<ITeaserBetPickValidator<ResultError>>('TEASER_PICK_VALIDATORS');
export const BETSTATION_REWARD_TOKENS_PICK_VALIDATORS = new InjectionToken<IBetstationRewardTokensPickValidator<ResultError>>(
    'BETSTATION_REWARD_TOKENS_PICK_VALIDATORS',
);

export const EDIT_BET_SLIP_VALIDATORS = new InjectionToken<IEditBetSlipValidator<BetslipError>>('EDIT_BET_SLIP_VALIDATORS');
export const CONTEXT_SLIP_VALIDATORS = new InjectionToken<IContextSlipValidator<BetslipError>>('CONTEXT_SLIP_VALIDATORS');
export const BET_BUILDER_SLIP_VALIDATORS = new InjectionToken<IBetBuilderSlipValidator<BetslipError>>('BET_BUILDER_SLIP_VALIDATORS');

export const PURE_BETSLIP_VALIDATORS = new InjectionToken<IPureBetslipValidator<BetslipError>>('PURE_BETSLIP_VALIDATORS');
export const CONTEXT_BETSLIP_VALIDATORS = new InjectionToken<IContextBetslipValidator<BetslipError>>('CONTEXT_BETSLIP_VALIDATORS');
export const REWARD_TOKENS_BETSLIP_VALIDATORS = new InjectionToken<IRewardTokensBetslipValidator<BetslipError>>('REWARD_TOKENS_BETSLIP_VALIDATORS');
export const BETSTATION_REWARD_TOKENS_BETSLIP_VALIDATORS = new InjectionToken<IBetstationRewardTokensBetslipValidator<BetslipError>>(
    'BETSTATION_REWARD_TOKENS_BETSLIP_VALIDATORS',
);
export const EDIT_BET_BETSLIP_VALIDATORS = new InjectionToken<IEditBetBetslipValidator<BetslipError>>('EDIT_BET_BETSLIP_VALIDATORS');

export const PURE_TYPE_BETSLIP_VALIDATORS = new InjectionToken<IPureTypeBetslipValidator<BetslipError>>('PURE_TYPE_BETSLIP_VALIDATORS');
export const SINGLE_BET_BETSLIP_VALIDATORS = new InjectionToken<ISingleBetBetslipValidator<BetslipError>>('SINGLE_BET_BETSLIP_VALIDATORS');
export const COMBO_BET_BETSLIP_VALIDATORS = new InjectionToken<IComboBetBetslipValidator<BetslipError>>('COMBO_BET_BETSLIP_VALIDATORS');
export const SYSTEM_BET_BETSLIP_VALIDATORS = new InjectionToken<ISystemBetBetslipValidator<BetslipError>>('SYSTEM_BET_BETSLIP_VALIDATORS');
export const TEASER_BET_BETSLIP_VALIDATORS = new InjectionToken<ITeaserBetBetslipValidator<BetslipError>>('TEASER_BET_BETSLIP_VALIDATORS');
export const EDIT_BET_TYPE_BETSLIP_VALIDATORS = new InjectionToken<IEditBetTypeBetslipValidator<BetslipError>>('EDIT_BET_TYPE_BETSLIP_VALIDATORS');
export const GROUP_PICK_COMBO_PICK_VALIDATORS = new InjectionToken<IPurePickValidator<ResultError> | IPureLinearPickValidator<ResultError>>(
    'GROUP_PICK_COMBO_PICK_VALIDATORS',
);
